<template>
  <div>
    <div :class="{'vdatetime-time-picker': true, 'vdatetime-time-picker__with-suffix': use12Hour}">

      <h3 class="dt-section-label">
        {{ $t('Input.dateTime.hours') }}
      </h3>

      <div class="vdatetime-time-picker__list vdatetime-time-picker__list--hours" ref="hourList">
        <div  class="dt-scroller">

          <!-- div class="dt-nav-arrows left">
            <icon name="angle-left" />
          </div -->

          <div class="dt-time-items">
            <nobr id="scroller_hours">
              <div class="vdatetime-time-picker__item" v-for="hour in hours" @click="selectHour(hour)" :key="hour.number" :class="{'vdatetime-time-picker__item--selected': hour.selected, 'vdatetime-time-picker__item--disabled': hour.disabled}">
                <div class="dt-centerer">
                  <span>
                    {{ formatHour(hour.number) }}
                  </span>
                </div>
              </div>
            </nobr>
          </div>

          <!-- div class="dt-nav-arrows right">
            <icon name="angle-right" />
          </div -->

        </div>
      </div>
    </div>

    <!-- Minutes -->
    <div :class="{'border-bot': true, 'vdatetime-time-picker': true, 'vdatetime-time-picker__with-suffix': use12Hour}">

      <h3 class="dt-section-label">
        {{ $t('Input.dateTime.minutes') }}
      </h3>

      <div class="vdatetime-time-picker__list vdatetime-time-picker__list--minutes" ref="minuteList">
        <div  class="dt-scroller">

          <!-- div class="dt-nav-arrows left">
            <icon name="angle-left" />
          </div -->

          <div class="dt-time-items">
            <nobr id="scroller_minutes">
              <div class="vdatetime-time-picker__item" v-for="minute in minutes" :key="minute.number" @click="selectMinute(minute)" :class="{'vdatetime-time-picker__item--selected': minute.selected, 'vdatetime-time-picker__item--disabled': minute.disabled}">
                <div class="dt-centerer">
                  <span>
                    {{ minute.number }}
                  </span>
                </div>
              </div>
            </nobr>
          </div>

          <!-- div class="dt-nav-arrows right">
            <icon name="angle-right" />
          </div -->
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { hours, minutes, pad, timeComponentIsDisabled } from './util'

export default {
  props: {
    hour: {
      type: Number,
      required: true
    },
    minute: {
      type: Number,
      required: true
    },
    use12Hour: {
      type: Boolean,
      default: false
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    minTime: {
      type: String,
      default: null
    },
    maxTime: {
      type: String,
      default: null
    }
  },

  computed: {
    hours () {
      return hours(this.hourStep).filter(hour => {
        if (!this.use12Hour) {
          return true
        } else {
          if (this.hour < 12) {
            return hour < 12
          } else {
            return hour >= 12
          }
        }
      }).map(hour => ({
        number: pad(hour),
        selected: hour === this.hour,
        disabled: timeComponentIsDisabled(this.minHour, this.maxHour, hour)
      }))
    },
    minutes () {
      return minutes(this.minuteStep).map(minute => ({
        number: pad(minute),
        selected: minute === this.minute,
        disabled: timeComponentIsDisabled(this.minMinute, this.maxMinute, minute)
      }))
    },
    minHour () {
      return this.minTime ? parseInt(this.minTime.split(':')[0]) : null
    },
    minMinute () {
      return this.minTime && this.minHour === this.hour ? parseInt(this.minTime.split(':')[1]) : null
    },
    maxHour () {
      return this.maxTime ? parseInt(this.maxTime.split(':')[0]) : null
    },
    maxMinute () {
      return this.maxTime && this.maxHour === this.hour ? parseInt(this.maxTime.split(':')[1]) : null
    }
  },

  methods: {
    selectHour (hour) {
      if (hour.disabled) {
        return
      }

      this.$emit('change', { hour: parseInt(hour.number) })
    },
    selectMinute (minute) {
      if (minute.disabled) {
        return
      }

      this.$emit('change', { minute: parseInt(minute.number) })
    },
    selectSuffix (suffix) {
      if (suffix === 'am') {
        if (this.hour >= 12) {
          this.$emit('change', { hour: parseInt(this.hour - 12), suffixTouched: true })
        }
      }
      if (suffix === 'pm') {
        if (this.hour < 12) {
          this.$emit('change', { hour: parseInt(this.hour + 12), suffixTouched: true })
        }
      }
    },
    formatHour (hour) {
      const numHour = Number(hour)
      if (this.use12Hour) {
        if (numHour === 0) {
          return 12
        }
        if (numHour > 12) {
          return numHour - 12
        }
        return numHour
      }
      return hour
    }
  },

  mounted () {
    const selectedHour = this.$refs.hourList.querySelector('.vdatetime-time-picker__item--selected')
    const selectedMinute = this.$refs.minuteList.querySelector('.vdatetime-time-picker__item--selected')
    this.$refs.hourList.scrollTop = selectedHour ? selectedHour.offsetTop - 250 : 0
    this.$refs.minuteList.scrollTop = selectedMinute ? selectedMinute.offsetTop - 250 : 0

    $('.dt-time-items').on('mousewheel DOMMouseScroll', function(event){
      let delta = Math.max(
        -1,
        Math.min(
          1,
          (event.originalEvent.wheelDelta || -event.originalEvent.detail)
        )
      )

      $(this).scrollLeft($(this).scrollLeft() - (delta * 25))
      event.preventDefault();
    })
  }
}
</script>

<style>
.vdatetime-time-picker {
  box-sizing: border-box;
}

.vdatetime-time-picker__list {
  float: left;
  width: 50%;
  height: 305px;
}

.vdatetime-time-picker__with-suffix .vdatetime-time-picker__list {
  width: 33.3%;
}

.vdatetime-time-picker__item {
  padding: 10px 0;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  transition: font-size .3s;
}

.vdatetime-time-picker__item:hover {
  font-size: 32px;
}

.vdatetime-time-picker__item--selected {
  color: #3f51b5;
  font-size: 32px;
}

.vdatetime-time-picker__item--disabled {
  opacity: 0.4;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/standard/input/vue-datetime/DatetimeTimePicker.vue?39965dc3